export enum variants {
    common = 'common',
    modal = 'modal',
    popper = 'popper',
}
